"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M24 4.1A19.9 19.9 0 1 0 43.9 24 19.9 19.9 0 0 0 24 4.1zm-.062 33.887a2.844 2.844 0 1 1 0-5.688 2.718 2.718 0 0 1 2.862 2.824 2.665 2.665 0 0 1-2.863 2.864zm1.514-11.457a4.3 4.3 0 0 0 .736 2.168.212.212 0 0 1-.2.327h-3.6a.53.53 0 0 1-.491-.2 4.412 4.412 0 0 1-1.064-2.783c0-3.274 5.36-5.278 5.36-8.552 0-1.6-1.309-2.987-3.8-2.987a11.816 11.816 0 0 0-4.951 1.023c-.164.082-.286 0-.286-.164v-3.235c0-.164 0-.327.163-.41a13.989 13.989 0 0 1 6.1-1.269c4.787 0 7.856 2.742 7.856 6.67-.013 4.501-5.823 7.082-5.823 9.412z" })
);

